import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CancelAppointmentContext } from './context.js';

var CancelAppointmentProvider = (_param)=>{
    var { children  } = _param, config = swcHelpers.objectWithoutProperties(_param, [
        "children"
    ]);
    const [appointment, setAppointment] = React.useState(undefined);
    const [store, setStore] = React.useState(undefined);
    const values = React.useMemo(()=>({
            config,
            store,
            appointment,
            setAppointment,
            setStore
        })
    , [
        appointment,
        store,
        config,
        setStore,
        setAppointment
    ]);
    return /*#__PURE__*/ React.createElement(CancelAppointmentContext.Provider, {
        value: values
    }, children);
};

export { CancelAppointmentProvider };
//# sourceMappingURL=provider.js.map
